const Title = ({ title }: { title: string }) => (
  <div className="my-form-tit-box">
    <div className="tit-txt">{title}</div>
  </div>
);

export default Title;
